import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/flows')({
  head: () => ({
    meta: [{ title: 'Flows | Tekst' }],
  }),
  component: FlowsLayout,
});

function FlowsLayout() {
  return <Outlet />;
}
